const displayConsoleArt = () => {
    const currentYear = new Date().getFullYear();
    const asciiArt = `
%c
╔══════════════════════════════════════════════════════════════╗
║                                                              ║
║      ██████╗  ██████╗ █████╗  ██████╗██╗      █████╗ ██████╗ ║
║      ██╔══██╗██╔════╝██╔══██╗██╔════╝██║     ██╔══██╗██╔══██╗║
║      ██║  ██║██║     ███████║██║     ██║     ███████║██████╔╝║
║      ██║  ██║██║     ██╔══██║██║     ██║     ██╔══██║██╔══██╗║
║      ██████╔╝╚██████╗██║  ██║╚██████╗███████╗██║  ██║██████╔╝║
║      ╚═════╝  ╚═════╝╚═╝  ╚═╝ ╚═════╝╚══════╝╚═╝  ╚═╝╚═════╝ ║
║                                                              ║
║         🔬 Welcome to DCACLab Virtual Electronics Lab! 🔬     ║
║                                                              ║
║                      Virtual Circuit Design                  ║
║                    & Simulation Platform                     ║
║                                                              ║
║           © ${currentYear} DCACLab - All Rights Reserved               ║
║                                                              ║
║     🚀 Build circuits, learn electronics, innovate! 🚀       ║
║                                                              ║
║               Made with ❤️  for educators & students         ║
║                                                              ║
╚══════════════════════════════════════════════════════════════╝
`;

    const styles = [
        'color: #2185D0; font-family: monospace; font-size: 12px; font-weight: bold; text-shadow: 1px 1px 2px rgba(0,0,0,0.3);'
    ];

    // Use different console methods to avoid being stripped
    const c = window.console;
    if (c && c.log) {
        c.log(asciiArt, ...styles);
        c.log('%c🎯 Welcome to DCACLab! 🎯', 'color: #21BA45; font-size: 16px; font-weight: bold;');
        c.log('%cExplore virtual electronics and build amazing circuits!', 'color: #767676; font-size: 14px;');
        c.log('%c🔧 Happy coding and circuit building! 🔧', 'color: #FF851B; font-size: 14px; font-weight: bold;');
        c.log('%cFound a bug or have suggestions? We\'d love to hear from you!', 'color: #6435C9; font-size: 12px;');
        c.log('%c✨ Enjoy your virtual electronics experience! ✨', 'color: #E03997; font-size: 14px; font-weight: bold;');
    }
};

export default displayConsoleArt;